import React, { useRef } from 'react';
import { HdTooltip, HdIcon } from '../../../../components';
import styles from '../query-output-table/QueryOutputTable.module.scss';

interface Props {
  value: any;
  canShowJSONDialog?: boolean;
  json?: string;
  headerName?: string;
  openJSONDialog?: Function;
}

export default function QueryTableCell({ value, canShowJSONDialog, openJSONDialog }: Props) {
  const cellRef = useRef(null);
  const json = value?.json;

  return json ? (
    <>
      {canShowJSONDialog && (
        <div className='data-table__cell-container'>
          <div className='center-flex-row'>
            <HdTooltip title='Click to expand' placement='bottom-start'>
              <button className={styles.expandJSONButton} onClick={() => openJSONDialog()}>
                <HdIcon name='popup' />
              </button>
            </HdTooltip>

            <span className='text-ellipsis ml-1'>{json}</span>
          </div>
        </div>
      )}

      {!canShowJSONDialog && (
        <HdTooltip title={json} placement='bottom-start' mode='surface'>
          <div className='data-table__cell-container'>{json}</div>
        </HdTooltip>
      )}
    </>
  ) : (
    <HdTooltip title={value} placement='bottom-start' enableOnTextOverflow={true}>
      <div className='data-table__cell-container' ref={cellRef}>
        {value?.toString()}
      </div>
    </HdTooltip>
  );
}
